import React from "react";
import H1 from "../../components/H1";
import H3 from "../../components/H3";
import { StyledStartPage } from "./StartPage.css";

const StartPage = () => {
  return (
    <StyledStartPage>
      <H1>Kacper Kuczewski</H1>
      <H3>Fullstack Developer</H3>
    </StyledStartPage>
  );
};

export default StartPage;
